import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import styles from './excursion.module.css';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Excursion on September 21st`}</h2>
    <ul className={styles.summary}>
  <li>viewpoint Kamenjak at Vransko lake</li>
  <li>Biograd na moru</li>
  <li>olive oil and wine tasting</li>
    </ul>
    <ul className={styles.photos}>
  <li>
    <img alt="Vransko lake" src="https://res.cloudinary.com/pubmet/image/upload/c_scale,h_274/v1/excursion-vransko-lake/vransko-lake.jpg" height="137" />
  </li>
  <li>
    <img alt="Biograd na moru" src="https://res.cloudinary.com/pubmet/image/upload/c_scale,h_274/v1/excursion-vransko-lake/biograd-na-moru.jpg" height="137" />
  </li>
  <li>
    <img alt="olive oil being poured into a tasting dish with other types of olive oil" src="https://res.cloudinary.com/pubmet/image/upload/c_scale,h_274/v1/excursion-vransko-lake/olive-oil-tasting.jpg" height="137" />
  </li>
  <li>
    <img alt="wine being poured into a glass" src="https://res.cloudinary.com/pubmet/image/upload/c_scale,h_274/v1/excursion-vransko-lake/wine-tasting.jpg" height="137" />
  </li>
    </ul>
    <p>{`This excursion will show you southern part of Zadar region with included Vransko lake, Biogard and agricultural cooperative. After an hour-long drive, first stop will be Kamenjak viewpoint. At the top of Kamenjak Hill, above the middle of Lake Vrana, a viewpoint was constructed in 2006. Two connected buildings were built and decorated in traditional style, and next to them there are large signboards that tell the story of this region that is older than two millennia, a large plateau with benches for rest and enjoyment, a panoramic telescope and what is most important: a view of the entire lake, at the beginning of the Kornati islands, the Island of Murter, Pirovac, Drage, Pakoštane... While guide is telling you a story about area, enjoy the view.`}</p>
    <p>{`From Kamenjak, weʼll continue to Biograd na Moru. The crowning site of the Croatian and Croatian-Hungarian rulers, Biograd is today a capital Riviera at the doors of the Kornati islands. Biograd has it all – from beautiful pebble beaches to its rich historical and cultural heritage. You wonʼt be dissapointed by this charming seaside town which was once occupied by kings of Croatia. The core of this ancient town is located on a small peninsula dotted with its cultural and historical heritage that testifies about its turbulent past.`}</p>
    <p>{`Afterwards, weʼll head to place called Polača in Ravni kotari. Two locals established the agricultural cooperative with the aim of development rural area and production of top quality products through olive growing (edible olives in different preparation and extra virgin olive oil) and viticulture as well as figs and products made from figs. First will follow traditional lunch with “peka” and later will follow wine (3 types) and olive oil tasting with tour of production area.`}</p>
    <p>{`Tour will end by returning to Zadar.`}</p>
    <h3>{`Schedule`}</h3>
    <ul>
      <li parentName="ul">{`08:00-09:15 → bus ride to Kamenjak viewpoint`}</li>
      <li parentName="ul">{`09:15-10:15 → brief tour and enjoying the panoramic view`}</li>
      <li parentName="ul">{`10:15-11:50 → bus ride to Biograd`}</li>
      <li parentName="ul">{`11:50-12:30 → Biograd city tour`}</li>
      <li parentName="ul">{`12:30-13:15 → free time activities (swimming, sigthseeing, etc.)`}</li>
      <li parentName="ul">{`13:15-13:35 → bus ride to Polača`}</li>
      <li parentName="ul">{`13:35 → lunch, wine and olive oil tasting with tour of production area`}</li>
      <li parentName="ul">{`15:00 → bus ride to Zadar`}</li>
    </ul>
    <h3>{`Price per person`}</h3>
    <ul>
      <li parentName="ul">{`8-13 → 590,00 kn`}</li>
      <li parentName="ul">{`14-19 → 470,00 kn`}</li>
      <li parentName="ul">{`20-25 → 440,00 kn`}</li>
      <li parentName="ul">{`26-31 → 395,00 kn`}</li>
      <li parentName="ul">{`32-37 → 375,00 kn`}</li>
      <li parentName="ul">{`38-43 → 360,00 kn`}</li>
    </ul>
    <p>{`For lunch at this agriculture property, minimum number of persons is 10. For less than 10, lunch will be organized in Biograd.`}</p>
    <p>{`The price includes transfer with bus, guide, entrance fee for Natural Park Vransko Lake, lunch (aperitif, peka with side dish and salad), wine and olive oil tasting, tour of wine and olive oil production area.`}</p>
    <a href="http://www.adriatictravel.eu/" title="Adriatic Travel">
  <img alt="Adriatic Travel" src="https://res.cloudinary.com/pubmet/image/upload/e_trim:10,c_scale,w_512/v1563532357/adriatic-travel.png" width="256" />
    </a>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      